import { render, staticRenderFns } from "./SlaBadgeVerde.vue?vue&type=template&id=0a17780d&"
import script from "./SlaBadgeVerde.vue?vue&type=script&lang=js&"
export * from "./SlaBadgeVerde.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports